// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"123":"eace5640","716":"3b8a5b31"}[chunkId] + ".chunk.js");